import { Button, Col, Row, Text } from 'components';
import { Api } from 'lib';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';

const Container = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
  background-color: #fff;
`;

const CustomInput = styled.input`
  width: 80px;
  height: 20px;
  padding: 2px;
  border: 1px solid #ddd;
  border-radius: 5px;
`;

const DataInfo = ({ visible, close, user }) => {
  const [teamId, setTeamId] = useState(''),
    [playerId, setPlayerId] = useState(''),
    dispatch = useDispatch();

  useEffect(() => {
    if (!user) return;

    setTeamId(user.dataInfo?.teamId);
    setPlayerId(user.dataInfo?.playerId);
  }, [user]);

  async function submit(e) {
    const data = { teamId, playerId, userId: user._id };
    const res = await Api.post('/admin/updateDataInfo', data);
    if (!res) return;

    dispatch({
      type: 'ADMIN_EDIT_USER',
      payload: { _id: user._id, dataInfo: data }
    });

    dispatch({
      type: 'HANDLE_RES',
      payload: { res: 'Data has been saved succsefully' }
    });

    close();
  }

  if (!visible) return null;

  return (
    <Container>
      <Col start between ht="100%">
        <Col start pad="16px" wid="calc(100% - 32px)">
          <Row noFlex between wid="100%" center>
            <Text med marg="0 12px 0 0">
              Team id
            </Text>

            <CustomInput value={teamId} onChange={({ target }) => setTeamId(target.value)} />
          </Row>

          <Row noFlex between wid="100%" center marg="8px 0 0">
            <Text med marg="0 12px 0 0">
              Player id
            </Text>

            <CustomInput value={playerId} onChange={({ target }) => setPlayerId(target.value)} />
          </Row>
        </Col>

        <Row noFlex pad="16px">
          <Button small text="Cancel" onClick={close} marg="0 8px 0 0" />
          <Button small text="Save" onClick={submit} />
        </Row>
      </Col>
    </Container>
  );
};

export default DataInfo;
